<template>
  <div>
    <section>
      <v-navigation-drawer
        dark
        color="#00ACC1"
        width="75"
        v-model="drawer"
        fixed
        app>
        <v-list
          v-for="(item, index) in menu"
          :key="index">
          <v-list-item>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-card
                  width="75"
                  height="75"
                  color="transparent"
                  flat
                  class="cursor-pointer ma-auto"
                  v-bind="attrs"
                  v-on="on"
                  :to="item.link">
                  <v-card-title 
                    class="justify-center pb-1">
                    <v-icon :color="item.link.split('/')[1] === $route.path.split('/')[1] ? '#ffffff' : '#ffffff80'">
                      {{ item.icon }}
                    </v-icon>
                  </v-card-title>
                  
                  <v-card-text 
                    class="text-center one-line pa-0" 
                    style="font-size: 10px;"
                    :class="item.link.split('/')[1] === $route.path.split('/')[1] ? 'white--text font-weight-bold' : ''">
                    {{ item.label }}
                  </v-card-text>
                </v-card>
              </template>
              <span>
                {{ item.label }}
              </span>
            </v-tooltip>

            <v-divider
              vertical
              inset
              class="my-4"
              v-if="item.link.split('/')[1] === $route.path.split('/')[1]"
              style="border-width: 5px; border-color: #ffffff; border-radius: 25px; position: absolute; height: 40px; top: 1px; right: -5px;">
            </v-divider>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>

      <v-app-bar
        :clipped-left="clipped"
        color="#fff"
        fixed
        nav
        elevation="0"
        app>
        <v-app-bar-nav-icon class="hidden-lg-and-up" @click.stop="drawer = !drawer"/>
        
        <v-toolbar-title 
          class="body-2 pl-5 d-flex align-center">
          <span class="font-weight-bold black--text">
            VENOM AMJ
          </span>

          <v-divider
            class="mx-3"
            vertical
            style="min-height: 25px !important;
            height: 25px
            min-width: 3px;
            margin-top: auto;
            margin-bottom: auto;
            background: #dadada;">
          </v-divider>

          <span class="text-second">
            {{ $route.meta.title }}
          </span>
        </v-toolbar-title>

        <v-spacer/>

        <!-- <v-menu
          close-on-content-click nudge-width="250" offset-x>
          <template v-slot:activator="{ on }">
            <div v-on="on" @click="fetch()">
              <v-badge v-if="pagination.total_data > 0"
                class="ml-4 cursor-pointer"
                color="red"
                overlap>
                <span slot="badge" v-if="pagination.total_data > 9">
                  9+
                </span>
                <span slot="badge" v-else>
                  {{ pagination.total_data }}
                </span>
                <span slot="default">
                  <v-icon color="orange">mdi-bell</v-icon>
                </span>
              </v-badge>
              <span class="ml-4 cursor-pointer" slot="default"
                v-else>
                <v-icon color="orange">mdi-bell</v-icon>
              </span>
            </div>
          </template>

          <v-card>
            
          </v-card>
        </v-menu> -->

        <div class="ml-6 mr-1 hidden-md-and-down">
          <v-menu
            :close-on-click="true"
            :close-on-content-click="true"
            :offset-y="true">
            <template v-slot:activator="{ on, attrs }">
              <v-list 
                flat
                class="py-0" 
                color="#00ACC1" 
                style="border-radius: 50px;">
                <v-list-item to="/profile"
                  class="pl-2" 
                  v-bind="attrs"
                  v-on="on"
                  style="border-radius: 50px;">
                  <v-list-item-avatar 
                    size="35" 
                    color="white" 
                    class="my-0" 
                    style="border: 3px solid #fff;">
                    <v-img alt="VENOM"
                      :src="user.image_url === '' ? require('@/assets/image/member-default.jpg') : user.image_url">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            color="#00ACC1">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-list-item-avatar>

                  <v-list-item-content class="py-0 white--text" style="width: 150px;">
                    <v-list-item-title 
                      class="body-2 font-weight-bold text-capitalize pt-0">
                      {{ user.name }}
                    </v-list-item-title>

                    <v-list-item-subtitle 
                      class="font-weight-light white--text pb-0" 
                      style="font-size: 10px;">
                      {{ user.position }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </template>
          </v-menu>
        </div>

        <div 
          class="pr-6 cursor-pointer hidden-md-and-down"
          @click="logout">
          <v-card-title 
            class="justify-center pb-0">
            <v-icon color="red">mdi-logout-variant</v-icon>
          </v-card-title>

          <v-card-text 
            class="text-center pa-0 red--text" 
            style="font-size: 10px;">
            Keluar
          </v-card-text>
        </div>
      </v-app-bar>
    </section>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../service/Axios";
  import { TokenService } from "../service/Storage.Service";
  import firebase from "firebase";
  export default {
    data () {
      return {
        clipped: false,
        drawer: true,
        list: [],
        pagination: {},
        process: {
          form: false
        },
        message: {
          error: ''
        }
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      token () {
        return this.$store.state.token
      },
      menu () {
        return this.$store.state.menu
      }
    },
    created () {
      
    },
    mounted () {
      const debounce = (fn) => {
        let frame;
        return (...params) => {
          if (frame) { 
            cancelAnimationFrame(frame)
          }
          frame = requestAnimationFrame(() => {
            fn(...params)
          })
        } 
      };
      const storeScroll = () => {
        document.documentElement.dataset.scroll = window.scrollY
      }
      document.addEventListener('scroll', debounce(storeScroll), { passive: true })
      storeScroll()
    },
    methods: {
      async logout() {
        this.message.error = ''

        this.process.form = true
        
        await post(`admin/logout`)
        .then(response => {
          let res = response.data
          if (res.status === 200) {
            TokenService.removeToken()

            this.logoutGoogle()
          } else {
            this.process.form = false
            this.message.error = res.message
          }
        })
      },
      async logoutGoogle() {
        await firebase.auth().signOut().then(() => {
          window.location = '/'
        }).catch((error) => {
          console.log(error)
        })
      }
    }
  }
</script>